import * as React from 'react';

import { useQuestionRules } from '../RuleBuilder/useQuestionRules';

type QuestionRulesContextType = ReturnType<typeof useQuestionRules> & {
  question: ScreenerField;
  screener: Screener;
  onClose: () => void;
  setQuestions: (questions: ScreenerField[]) => void;
};

const QuestionRulesContext = React.createContext<QuestionRulesContextType | undefined>(undefined);

export const useQuestionRulesContext = (): QuestionRulesContextType => {
  const context = React.useContext(QuestionRulesContext);
  if (context === undefined) {
    throw new Error('useQuestionRulesContext must be used within a QuestionRulesProvider');
  }
  return context;
};

interface QuestionRulesProviderProps {
  children: React.ReactNode;
  question: ScreenerField;
  screener: Screener;
  onClose: () => void;
  setQuestions: (questions: ScreenerField[]) => void;
}

export const QuestionRulesProvider: React.FC<QuestionRulesProviderProps> = ({
  children,
  question,
  screener,
  onClose,
  setQuestions
}) => {
  const questionRulesData = useQuestionRules(question, screener, onClose, setQuestions);

  const contextValue = {
    ...questionRulesData,
    question,
    screener,
    onClose,
    setQuestions
  };

  return <QuestionRulesContext.Provider value={contextValue}>{children}</QuestionRulesContext.Provider>;
};
